import Chart from 'chart.js/auto';
import { CategoryScale } from 'chart.js';
import { Line } from 'react-chartjs-2';
import { CertificationCompletionEntry } from 'types/admin/analytics';
import { options } from '../../consts/lineChartConfig';
import { getLastGivenMonths } from 'utilities/getChartTimeRange';
import { getCertificationTrendChartData } from 'utilities/certificationCompletions';

Chart.register(CategoryScale);

export const CertificationTrendsChart = ({
  trends,
  chartColors,
}: {
  trends: [string, CertificationCompletionEntry][];
  chartColors: string[];
}) => {
  const months = getLastGivenMonths(6);
  const chartData = getCertificationTrendChartData(trends, chartColors, months);

  return (
    <div style={{ height: '260px' }}>
      <Line data={chartData} options={options} />
    </div>
  );
};
